module.exports = __webpack_public_path__ + "img/67.135f7952.jpg";